import { Col } from "antd";
import type React from "react";
import { useAudienceModalContext } from "../../providers/AudienceModalContext";

export interface AudienceModalResultsProps {
	count?: number;
	isLoading?: boolean;
}

const AudienceModalResults: React.FC<AudienceModalResultsProps> = ({
	count = 0,
	isLoading = false,
}) => {
	const { step, publicSettings, searchResults } = useAudienceModalContext();

	// Only show results in search step
	if (step !== "search") {
		return null;
	}

	const displayCount = count || searchResults?.data?.count || 0;

	return (
		<Col span={24}>
			<div
				className="p-4 rounded-full border"
				style={{
					backgroundColor:
						publicSettings?.PRIMARY_LIGHT_COLOR?.valueString || "#f0f5ff",
					borderColor: publicSettings?.PRIMARY_COLOR?.valueString || "#1890ff",
					color: publicSettings?.PRIMARY_COLOR?.valueString || "#1890ff",
				}}
			>
				<p className="text-center text-lg font-bold m-0">
					{isLoading ? "検索中..." : `検索結果：${displayCount}件`}
				</p>
			</div>
		</Col>
	);
};

export default AudienceModalResults;
